import { css } from "@emotion/react";
import { color } from "@moneyforward/mfx_biz_react_components";

export const HorizontalRule = ({}) => <hr css={styleHorizontalRule} />;

const styleHorizontalRule = css`
  border-top: 0.2rem solid ${color.gray300};
`;
